/*
 * Generic tile carousel — used by promo-tiles and category-tiles.
 * Adds click-through navigation. Mobile scroll-snap is preserved.
 */
(function () {
  function init(section) {
    var track = section.querySelector('[data-tile-track]');
    var prev = section.querySelector('[data-tile-prev]');
    var next = section.querySelector('[data-tile-next]');
    if (!track || !prev || !next) return;

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var rect = first.getBoundingClientRect();
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return rect.width + gap;
    }

    function isScrollable() {
      return track.scrollWidth > track.clientWidth + 1;
    }

    function updateBtns() {
      if (!isScrollable()) {
        prev.style.display = 'none';
        next.style.display = 'none';
        return;
      }
      prev.style.display = '';
      next.style.display = '';
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateBtns, { passive: true });
    window.addEventListener('resize', updateBtns);

    // initial state
    updateBtns();
  }

  function boot() {
    document.querySelectorAll('[data-tile-carousel]').forEach(function (el) {
      if (el.__tileCarouselReady) return;
      el.__tileCarouselReady = true;
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
